import { useRef, MutableRefObject } from 'react';

/**
 * Caches a value and returns a ref where the latest value is available as part of .current
 * @returns {{current: any}} Ref to latest version of toCache
 * @param {any} toCache
 */
export default function useCache<T>(toCache: T): MutableRefObject<T> {
  const ref = useRef(toCache);

  ref.current = toCache;

  return ref;
}
